export var TuiLinks = {
    freemiumTuiRemindURL: 'https://go.microsoft.com/fwlink/?linkid=2230754',
};
//# sourceMappingURL=constants.js.map